import React from "react";
import { Link, Redirect } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { useUser } from "~/Context/userContext";

const RegisterPage = () => {
  const { state: userState, dispatch } = useUser();

  if (!userState.loaded) {
    return null;
  }

  const isLoggedin = userState && userState.loggedin;

  if (!isLoggedin) {
    return (
      <div className="RegisterPageWrapper">
        <div className="page-header">
          <h2>Join Dream Chimney</h2>
          <p style={{ padding: '10px 0 20px' }}>
            There are two different ways you can join Dream Chimney.
            Read below to see which option works best for you or feel free to <a href="/contact" target="_blank">contact us</a>.
          </p>

          <Row className="register-page">
            <Col xs={{ span: 11, offset: 0 }} md={{ span: 6, offset: 0 }} lg={{ span: 4, offset: 1 }} className="register-left">
              <Card >
                <Card.Body>
                  <Card.Title>Become a Chimney</Card.Title>
                  <Card.Text>
                    Fill out a short list of questions so we can get to know you and your musical tastes. Once you are approved you will be able to...
                    <ul style={{ padding: '16px 30px' }}>
                      <li><strong>Post your favorite tracks</strong></li>
                      <li>Create a public profile page</li>
                      <li>Build track playlists</li>
                      <li>Save your favorite tracks</li>
                      <li>Access to all Dream Chimney sites</li>
                      <li>Discounts on releases and merch</li>
                      <li>Brag to your friends</li>
                    </ul>
                  </Card.Text>

                  <Link to="/apply">
                    <Button size="md" >
                      Apply Now
                    </Button>
                  </Link>
                </Card.Body>
              </Card>
            </Col>
            <Col xs={{ span: 11, offset: 0 }} md={{ span: 6, offset: 0 }} lg={{ span: 4, offset: 1 }} className="register-right">
              <Card >
                <Card.Body>
                  <Card.Title>Create a Dream Chimney Account</Card.Title>
                  <Card.Text>
                    A basic Dream Chimney account lets you...
                    <ul style={{ padding: '16px 30px' }}>
                      <li>Save your favorite tracks</li>
                      <li>Build track playlists</li>
                      <li>Create a public profile page</li>
                      <li>and much more...</li>
                    </ul>
                  </Card.Text>
                  <Button variant="primary" onClick={() => dispatch({ type: "register_open" })}>Join Now</Button>

                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }

  return (
    <Redirect
      to={{
        pathname: "/",
        state: {},
      }}
    />
  );
};

export default RegisterPage;
